(function(){
  if(window.__kvCardRot)return;window.__kvCardRot=1;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){e.target._vis=e.isIntersecting})},{threshold:.6});
  function scan(){document.querySelectorAll('.card-gallery slideshow-component').forEach(function(s){
    if(s._kv)return;s._kv=1;s._off=Math.floor(Math.random()*1800);io.observe(s)})}
  scan();
  new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
  setInterval(function(){
    if(document.hidden)return;
    document.querySelectorAll('.card-gallery slideshow-component').forEach(function(s){
      if(!s._vis||typeof s.next!=='function')return;
      setTimeout(function(){try{s.next()}catch(e){}},s._off);
    });
  },3200);
})();
